const action = {
    general: 'Podczas wykonywania działania wystąpił błąd. Spróbuj ponownie później.',
    sign_in_identifier_changed: 'Działanie nie może zmienić identyfikatora logowania użytego do tej weryfikacji.',
};
export default Object.freeze(action);
